import Menu from './Menu';
import Tree from './Tree';
import Header from './Header';
import Provider from './Provider';
import Search from './Search';
import Toolbar from './Toolbar';
import Breadcrumb from './Breadcrumb';
import ViewPort from './ViewPort';
import Aside from './Aside';

export default {
    Menu,
    Header,
    Provider,
    Search,
    Toolbar,
    Breadcrumb,
    ViewPort,
    Aside,
    Tree
}